import * as React from "react";
import { Option as UIOption, OptionProps } from "@stemscopes/ui";
import classNames from "classnames";
import styles from "./Option.module.css";

const Option: React.FC<OptionProps> = ({
  className,
  selectedClassName,
  activeClassName,
  ...rest
}) => (
  // eslint-disable-next-line
  // @ts-ignore
  <UIOption
    {...rest}
    className={classNames(styles.wrapper, className)}
    selectedClassName={classNames(styles.selected, selectedClassName)}
    activeClassName={classNames(styles.focused, activeClassName)}
  />
);

export default Option;
